import { Exclude, Transform } from 'class-transformer';

import Constants from '../utils/constants';
import { booleanTransform, centTransform } from '../utils/helper';
import { InsModDate } from './date.model';

export class Headquarter extends InsModDate {
	id!: number;
	name!: string;
	slug!: string;
	address?: string;
	streetno?: string;
	zipcode?: string;
	city?: string;
	province?: string;
	landline?: string;
	mobile?: string;
	email?: string;
	pec?: string;
	vatnum?: string;
	codunico?: string;
	ccp?: string;
	iban?: string;
	@Transform(booleanTransform)
	autoassigndelivery?: boolean;
	causale?: string;
	intestatario?: string;
	logo?: string;
	societa?: string;
	newpercentage?: number = Constants.DEFAULT_HEADQUARTER_NEWPERCENTAGE;
	dormientpercentage?: number = Constants.DEFAULT_HEADQUARTER_DORMIENTPERCENTAGE;
	portfoliopercentage?: number = Constants.DEFAULT_HEADQUARTER_PORTFOLIOPERCENTAGE;
	riscossioneserviziodefaultpaymode?: string;
	riscossioneserviziodefaultaccount?: string;
	riscossioneserviziodefaultreason?: string;
	riscossionequotadefaultaccount?: string;
	riscossionequotadefaultreason?: string;
	contributodefaultreason?: string;
	contributodefaultaccount?: string;
	pagamentofattorinodefaultreason?: string;
	pagamentofattorinodefaultaccount?: string;
	riscossioneserviziodefaultcostcenter?: string;
	riscossionequotadefaultcostcenter?: string;
	pagamentofattorinodefaultcostcenter?: string;
	contributodefaultcostecenter?: string;
	@Transform(centTransform)
	defaultquota?: number;
	@Transform(centTransform)
	sogliaquotaassociativa?: number;
	daystodormient!: number;

	@Exclude()
	previewurl?: string;

	get fulladdress(): string {
		let address = this.address ? this.address : '';
		if (this.streetno) {
			address += ` ${this.streetno}`;
		}
		if (this.province) {
			address += ` ${this.province}`;
		}
		if (this.city) {
			address += ` ${this.city}`;
		}
		if (this.zipcode) {
			address += ` ${this.zipcode}`;
		}
		return address;
	}
}

export class HeadquarterTemplate {
	id?: number;
	hid!: number;
	templatelettera?: string;
	templateconfermaemail?: string;
}
